// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__HHutr"};